export default __webpack_public_path__ + "static/media/mp_verifing_account_new-01.127c079e.svg";